module.exports = __webpack_public_path__ + "img/sticker_22.da4e834a.svg";